import React from 'react';
import {useFragment} from "react-relay";
import {allContractsDropdown} from "../contracts/ContractFragments";
import graphql from "babel-plugin-relay/macro";
import {useForm} from "react-hook-form";
import NewModal from "../../components/common/modals/NewModal";
import HorizontalFormSelect from "../../components/common/horizontal-form-inputs/HorizontalFormSelect";
import HorizontalFormInput from "../../components/common/horizontal-form-inputs/HorizontalFormInput";

const NewFacilityModal = ({showModal, onClose, contracts}) => {
    const mutation = graphql`
    mutation NewFacilityModalMutation($contractId: ID!, $name: String!, $npi: String!, $nickName: String!) {
        facility {
            create(input: {legalContractId: $contractId, name: $name, nickName: $nickName, npi: $npi}) {
                facility {
                    id
                }
            }
        }
    }`
    const allContracts = useFragment(allContractsDropdown, contracts).map(c => {return {value: c.id, label: c.name}});
    const defaultValues = {
        name:'',
        nickName:'',
        npi:'',
        contractId:''
    }
    const methods = useForm({defaultValues: defaultValues})
    return (
        <NewModal showModal={showModal} 
                  onClose={onClose} 
                  methods={methods} 
                  title={"New Facility"}
                  redirectUrl={"/facilities/"}
                  mutation={mutation}
                  returnedIdKey={"facility.create.facility.id"}
        >
            <HorizontalFormSelect options={allContracts} controlId={"contractId"} label={"Contract"} validation={{required:"Contract is required"}} />
            <HorizontalFormInput controlId={"npi"} label={"Npi"} validation={{required:"Npi is required"}} />
            <HorizontalFormInput controlId={"name"} label={"Name"} validation={{required:"Name is required"}} />
            <HorizontalFormInput controlId={"nickName"} label={"Nick Name"} />
        </NewModal>
    )
}

NewFacilityModal.propTypes = {}
export default NewFacilityModal